import styled from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.gray};
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  width: 100%;
`;
